import * as yup from 'yup'

// see docs at https://github.com/jquense/yup

// export the yup field types
export const v = {
  object: yup.object,
  string: yup.string,
  number: yup.number,
  boolean: yup.boolean,
  array: yup.array,
  mixed: yup.mixed,
  date: yup.date,
  ref: yup.ref,
  lazy: yup.lazy,
  reach: yup.reach,
  addMethod: yup.addMethod,
  ValidationError: yup.ValidationError,
  isSchema: yup.isSchema
}

// export a wrapper for yup validation
// this allows us to change the validation library in the future and all calls to this function will remain the same
export const validate = async (schema, data) => {
  return schema.validate(data, {
    abortEarly: false
  })
}

export const validateSync = (schema, data) => {
  return schema.validateSync(data)
}

export const isValid = async (schema, data) => {
  return schema.isValid(data)
}

export const isValidSync = (schema, data) => {
  return schema.isValidSync(data)
}
